export default "__VITE_ASSET__mc5a043A__"